import { colors } from '../colors'

export const orangePalette = {
  text: {
    primary: colors.text,
  },
  primary: {
    contrastText: '#ffffff',
    dark: '#ff9114',
    light: '#ffe5c7',
    main: colors.portal,
  },
  secondary: {
    contrastText: '#ffffff',
    dark: '#7c1310',
    main: '#e43631',
  },
}
